import { useState, memo } from 'react';
import { useSelector } from 'react-redux';
import * as S from './FiltersMenu.styled';
import { isAdvertiserRole } from 'store/selectors';
import { DropDownArrowUp, DropDownArrowDown, AllStatuses } from 'assets/icons';
import { advertiserFilterItems, publisherFilterItems } from 'constants';

const FiltersMenu = ({ handleChangeFilterState, filterState }) => {
  const [isOpen, setIsOpen] = useState(false);

  const isAdvertiser = useSelector(isAdvertiserRole);

  const filterItems = !isAdvertiser ? publisherFilterItems : advertiserFilterItems;

  return (
    <>
      {isOpen && <S.Slice onClick={() => setIsOpen(false)} />}
      <S.FiltersContainer onClick={() => setIsOpen(!isOpen)}>
        <S.FiltersHeader isOpen={isOpen} status={filterState.id} isPublisher={!isAdvertiser}>
          <AllStatuses style={{ minHeight: '8px', minWidth: '28px' }} />
          <span>{filterState.name}</span>
          {isOpen ? <DropDownArrowDown /> : <DropDownArrowUp />}
        </S.FiltersHeader>
        <S.Menu isOpen={isOpen} isPublisher={!isAdvertiser}>
          <S.ListWrap>
            <S.DropDownList>
              {filterItems.map((menuItem) => (
                <S.ListItem
                  key={menuItem.id}
                  isPublisher={!isAdvertiser}
                  status={menuItem.id}
                  onClick={() => handleChangeFilterState(menuItem)}
                >
                  <div style={{ display: 'flex', padding: '2px' }}>
                    <AllStatuses />
                  </div>
                  <span>{menuItem.name}</span>
                </S.ListItem>
              ))}
            </S.DropDownList>
          </S.ListWrap>
        </S.Menu>
      </S.FiltersContainer>
    </>
  );
};

export default memo(FiltersMenu);
